import { ca } from '@cian/analytics';
import { IAnalyticsUser } from '../../types/analytics';
import { formatPhoneForAnalytics } from '../formatters';

/**
 * Открытие формы для заполнения ОЗ
 * https://conf.cian.tech/pages/viewpage.action?pageId=1319910433
 */
export const trackRequestFormShow = (userPhone: string | null, analyticsUser: IAnalyticsUser) => {
  const extra = userPhone ? { phone: formatPhoneForAnalytics(userPhone) } : undefined;

  ca('eventSite', {
    action: 'show_sopr',
    category: 'newbuilding_finder',
    label: 'CallBack_popup_application',
    name: 'oldevent',
    user: {
      ...analyticsUser,
      extra,
    },
  });
};
